

const EditIcon = ({ onClick }) => {
    return (
        <svg
            width="24"
            height="24"
            onClick={onClick}
            className="cursor-pointer"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path fill="#B8AEC0" d="M432.4 787.2c-24.1 27.6-34.7 34.2-68.4 46.6-51.9 19.4-147 55.1-208.9 78.3-11.7 4.6-55.9 2.3-37.4-41.1 21-60.4 51.8-149.6 69.4-200.5 12.8-35.9 17.9-45.2 43.7-69.3l266.5-266.5L686 523.4C686 523.4 506.6 710.1 432.4 787.2z" />
            <path fill="#B8AEC0" d="M726.5 482.9 537.9 294.3 578.3 253.8 767 442.5Z" />
            <path fill="#B8AEC0" d="M888.3 321.2l-80.8 80.9L618.8 213.4l80.9-80.8c29.8-29.8 78-29.8 107.8 0l80.9 80.8C918.1 243.1 918.1 291.4 888.3 321.2z" />
        </svg>
    )
}
export default EditIcon;